import script from "./TakeSelfie.vue?vue&type=script&setup=true&lang=js"
export * from "./TakeSelfie.vue?vue&type=script&setup=true&lang=js"

import "./TakeSelfie.vue?vue&type=style&index=0&id=520bbf9b&lang=css"

const __exports__ = script;

export default __exports__